import React from 'react';
import { Layout } from '../../components/Layout';
import { FivePillarsWidget } from '../../components/widgets/FivePillarsWidget';
import { useAuth } from '../../contexts/AuthContext';

export const FivePillarsPage = () => {
  const { user } = useAuth();
  const isAdmin = ['super_admin', 'admin'].includes(user?.role);

  return (
    <Layout>
      <div className="space-y-6 p-6" data-testid="five-pillars-page">
        <FivePillarsWidget isAdmin={isAdmin} compact={false} />
      </div>
    </Layout>
  );
};

export default FivePillarsPage;
